export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q03_b.3d973e9a.png";